import axios from "axios";

export const apiRexxbot = axios.create({
	baseURL: "https://api.rexxbot.com/v1",
});
